import { FC } from "react";
import { Grid } from "@chakra-ui/react";

export const TeamUserListingItemGrid: FC = ({ children }) => (
  <Grid
    templateColumns={['auto', 'auto', '32px auto 100px']}
    templateRows={['auto, auto, auto', 'auto, auto, auto', 'auto']}
    columnGap={4}
    rowGap={1}
    alignItems="center"
    alignContent="center"
    justifyItems={['center', 'center', 'left']}
    minH="40px"
  >
    { children }
  </Grid>
);
